import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';

export const raindropListColumns = [
  'raindrop.id',
  'raindrop.name',
  'raindrop.providerId',
  'raindrop.casinoId',
  'raindrop.startDate',
  'raindrop.endDate',
  'raindrop.currency',
  'raindrop.freebetValue',
  'raindrop.dayBudget',
  'raindrop.totalBudget',
  // 'raindrop.claimLimitNumber',
  'raindrop.status',
  'raindrop.actions',
  'raindrop.timezone',
  'raindrop.distributionFrom',
  'raindrop.distributionTo',
  'raindrop.freebetsPerRain',
  'raindrop.rainsPerDay',
  'raindrop.claimLimitPeriod',
  'raindrop.minMultiplier',
  'raindrop.freebetValidityDate',
  'raindrop.claimDeadlineMinutes',
  'raindrop.playerMinBalance',
  'raindrop.playerMinWager',
  'raindrop.wagerPeriod',
] as const;

export type RaindropListColumns = (typeof raindropListColumns)[number];

export type RaindropListFilter = {
  'raindrop.id': string | undefined;
  'raindrop.name': string | undefined;
  'raindrop.providerId': string | undefined;
  'raindrop.casinoId': string | undefined;
  'raindrop.startDate': string | undefined;
  'raindrop.endDate': string | undefined;
  'raindrop.currency': string | undefined;
  'raindrop.freebetValue': number | undefined;
  'raindrop.dayBudget': number | undefined;
  'raindrop.totalBudget': number | undefined;
  // 'raindrop.claimLimitNumber': number | undefined;
  'raindrop.status': string | undefined;
  'raindrop.actions': string | undefined;
  'raindrop.timezone': string | undefined;
  'raindrop.distributionFrom': number | undefined;
  'raindrop.distributionTo': number | undefined;
  'raindrop.freebetsPerRain': number | undefined;
  'raindrop.rainsPerDay': number | undefined;
  'raindrop.claimLimitPeriod': string | undefined;
  'raindrop.minMultiplier': number | undefined;
  'raindrop.freebetValidityDate': string | undefined;
  'raindrop.claimDeadlineMinutes': number | undefined;
  'raindrop.playerMinBalance': number | undefined;
  'raindrop.playerMinWager': number | undefined;
  'raindrop.wagerPeriod': number | undefined;
};

export const defaultRaindropListFilter: RaindropListFilter = {
  'raindrop.id': undefined,
  'raindrop.name': undefined,
  'raindrop.providerId': undefined,
  'raindrop.casinoId': undefined,
  'raindrop.startDate': undefined,
  'raindrop.endDate': undefined,
  'raindrop.currency': undefined,
  'raindrop.freebetValue': undefined,
  'raindrop.dayBudget': undefined,
  'raindrop.totalBudget': undefined,
  // 'raindrop.claimLimitNumber': undefined,
  'raindrop.status': undefined,
  'raindrop.actions': undefined,
  'raindrop.timezone': undefined,
  'raindrop.distributionFrom': undefined,
  'raindrop.distributionTo': undefined,
  'raindrop.freebetsPerRain': undefined,
  'raindrop.rainsPerDay': undefined,
  'raindrop.claimLimitPeriod': undefined,
  'raindrop.minMultiplier': undefined,
  'raindrop.freebetValidityDate': undefined,
  'raindrop.claimDeadlineMinutes': undefined,
  'raindrop.playerMinBalance': undefined,
  'raindrop.playerMinWager': undefined,
  'raindrop.wagerPeriod': undefined,
};

export const raindropListColumnVisibilitySettings = {
  'raindrop.id': ColumnVisibilityType.Visible,
  'raindrop.name': ColumnVisibilityType.Visible,
  'raindrop.providerId': ColumnVisibilityType.CanBeHidden,
  'raindrop.casinoId': ColumnVisibilityType.CanBeHidden,
  'raindrop.startDate': ColumnVisibilityType.CanBeHidden,
  'raindrop.endDate': ColumnVisibilityType.CanBeHidden,
  'raindrop.currency': ColumnVisibilityType.CanBeHidden,
  'raindrop.freebetValue': ColumnVisibilityType.CanBeHidden,
  'raindrop.dayBudget': ColumnVisibilityType.CanBeHidden,
  'raindrop.totalBudget': ColumnVisibilityType.CanBeHidden,
  // 'raindrop.claimLimitNumber': ColumnVisibilityType.CanBeHidden,
  'raindrop.status': ColumnVisibilityType.CanBeHidden,
  'raindrop.actions': ColumnVisibilityType.CanBeHidden,
  'raindrop.timezone': ColumnVisibilityType.CanBeVisible,
  'raindrop.distributionFrom': ColumnVisibilityType.CanBeVisible,
  'raindrop.distributionTo': ColumnVisibilityType.CanBeVisible,
  'raindrop.freebetsPerRain': ColumnVisibilityType.CanBeVisible,
  'raindrop.rainsPerDay': ColumnVisibilityType.CanBeVisible,
  'raindrop.claimLimitPeriod': ColumnVisibilityType.CanBeVisible,
  'raindrop.minMultiplier': ColumnVisibilityType.CanBeVisible,
  'raindrop.freebetValidityDate': ColumnVisibilityType.CanBeVisible,
  'raindrop.claimDeadlineMinutes': ColumnVisibilityType.CanBeVisible,
  'raindrop.playerMinBalance': ColumnVisibilityType.CanBeVisible,
  'raindrop.playerMinWager': ColumnVisibilityType.CanBeVisible,
  'raindrop.wagerPeriod': ColumnVisibilityType.CanBeVisible,
} satisfies ColumnVisibilitySettings<RaindropListColumns>;

export const defaultRaindropListColumnVisibility = defaultColumnVisibilityParams(
  raindropListColumnVisibilitySettings
);

export const raindropListColumnVisibilityOptions = defaultColumnVisibilityOptions(
  raindropListColumns,
  raindropListColumnVisibilitySettings
);
